module.exports = __webpack_public_path__ + "static/34-ee217eea50d4174505f108a9d9d56829.gif";